// if (!customElements.get("product-form")) {
//   customElements.define(
//     "product-form",
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.element = this;
//         this.productData = JSON.parse(
//           this.querySelector(".ProductDataJson").textContent,
//         );
//         this.quantityInput = this.querySelector('input[name="quantity"]');
//         this.variantInput = this.querySelector('[name="id"]');
//         this.packData = {};

//         const bottleVariants = this.productData.variants.filter((variant) =>
//           /bottle/i.test(variant.title),
//         );

//         this.isBottleProduct = bottleVariants.length > 1;

//         if (this.isBottleProduct) {
//           this.productData.variants.forEach((variant) => {
//             const match = variant.title.match(/\d+/);

//             if (!match) return;

//             if (!/bottle/i.test(variant.title)) {
//               return;
//             }

//             const bottleCount = parseInt(match[0]);

//             this.packData[bottleCount] = {
//               variantId: variant.id,
//               available: variant.available,
//             };
//           });
//         }

//         this.form = this.querySelector("form");
//         this.variantIdInput.disabled = false;
//         this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
//         this.cart =
//           document.querySelector("cart-notification") ||
//           document.querySelector("cart-drawer");
//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText = this.submitButton.querySelector("span");

//         if (document.querySelector("cart-drawer"))
//           this.submitButton.setAttribute("aria-haspopup", "dialog");

//         this.hideErrors = this.dataset.hideErrors === "true";
//       }

//       async onSubmitHandler(evt) {
//         evt.preventDefault();

//         if (this.submitButton.getAttribute("aria-disabled") === "true") {
//           return;
//         }

//         // this.updateMode();

//         // return;

//         this.handleErrorMessage();
//         this.submitButton.setAttribute("aria-disabled", true);
//         this.submitButton.classList.add("loading");
//         this.querySelector(".loading__spinner").classList.remove("hidden");

//         if (this.element.classList.contains("split-mode")) {
//           try {
//             const qty = parseInt(this.quantityInput.value) || 1;
//             const items = this.buildCartItems(qty);

//             const response = await fetch("/cart/add.js", {
//               method: "POST",
//               headers: {
//                 "Content-Type": "application/json",
//               },
//               body: JSON.stringify({
//                 items,
//               }),
//             });

//             const responseData = await response.json();

//             if (responseData.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: "product-form",
//                 errors: responseData.errors || responseData.description,
//                 message: responseData.message,
//               });

//               this.handleErrorMessage(responseData.description);

//               return;
//             }

//             const sectionsResponse = await fetch(
//               `${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`,
//             );
//             const sectionsData = await sectionsResponse.json();
//             const cartResponse = await fetch("/cart.js");
//             const cartData = await cartResponse.json();

//             cartData.sections = sectionsData;

//             publish(PUB_SUB_EVENTS.cartUpdate, {
//               source: "product-form",
//               cartData,
//             });

//             this.cart.renderContents(cartData);

//             this.error = false;
//           } catch (error) {
//             console.error(error);
//             this.handleErrorMessage(error.message);
//           } finally {
//             this.submitButton.classList.remove("loading");

//             this.submitButton.removeAttribute("aria-disabled");

//             this.querySelector(".loading__spinner").classList.add("hidden");

//             if (this.cart && this.cart.classList.contains("is-empty")) {
//               this.cart.classList.remove("is-empty");
//             }
//           }

//           return;
//         }


//         const config = fetchConfig("javascript");
//         config.headers["X-Requested-With"] = "XMLHttpRequest";
//         delete config.headers["Content-Type"];

//         const formData = new FormData(this.form);
//         if (this.cart) {
//           formData.append(
//             "sections",
//             this.cart.getSectionsToRender().map((section) => section.id),
//           );
//           formData.append("sections_url", window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: "product-form",
//                 productVariantId: formData.get("id"),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });

//               this.handleErrorMessage(response.description);

//               const soldOutMessage =
//                 this.submitButton.querySelector(".sold-out-message");

//               if (!soldOutMessage) return;

//               this.submitButton.setAttribute("aria-disabled", true);
//               this.submitButtonText.classList.add("hidden");
//               soldOutMessage.classList.remove("hidden");
//               this.error = true;

//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;

//               return;
//             }

//             if (!this.error) {
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: "product-form",
//                 productVariantId: formData.get("id"),
//                 cartData: response,
//               });
//             }

//             this.error = false;

//             const quickAddModal = this.closest("quick-add-modal");

//             if (quickAddModal) {
//               document.body.addEventListener(
//                 "modalClosed",
//                 () => {
//                   setTimeout(() => {
//                     this.cart.renderContents(response);
//                   });
//                 },
//                 { once: true },
//               );

//               quickAddModal.hide(true);
//             } else {
//               this.cart.renderContents(response);
//             }
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove("loading");

//             if (this.cart && this.cart.classList.contains("is-empty")) {
//               this.cart.classList.remove("is-empty");
//             }

//             if (!this.error) {
//               this.submitButton.removeAttribute("aria-disabled");
//             }

//             this.querySelector(".loading__spinner").classList.add("hidden");
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         this.errorMessageWrapper =
//           this.errorMessageWrapper ||
//           this.querySelector(".product-form__error-message-wrapper");
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage =
//           this.errorMessage ||
//           this.errorMessageWrapper.querySelector(
//             ".product-form__error-message",
//           );

//         this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute("disabled", "disabled");
//           if (text) this.submitButtonText.textContent = text;
//         } else {
//           this.submitButton.removeAttribute("disabled");
//           this.submitButtonText.textContent = window.variantStrings.addToCart;
//         }
//       }

//       get variantIdInput() {
//         return this.form.querySelector("[name=id]");
//       }

//       getAvailablePacks() {
//         return Object.keys(this.packData)
//           .map(Number)
//           .sort((a, b) => b - a);
//       }

//       switchVariant(packSize) {
//         const data = this.packData[packSize];

//         if (!data) return;

//         const variantId = data.variantId;
//         const radio = document.querySelector(
//           `input[data-variant-id="${variantId}"]`,
//         );

//         if (radio) {
//           radio.checked = true;

//           radio.dispatchEvent(
//             new Event("change", {
//               bubbles: true,
//             }),
//           );
//         }
//       }

//       splitQuantity(total, packs) {
//         const result = [];

//         for (const pack of packs) {
//           const count = Math.floor(total / pack);

//           if (count > 0) {
//             result.push({
//               pack,
//               count,
//             });

//             total -= pack * count;
//           }
//         }

//         return result;
//       }

//       getSelectedSellingPlan() {
//         const checkedInput = document.querySelector(
//           'input[name="selling_plan"]:checked',
//         );

//         if (checkedInput && checkedInput.value) {
//           return checkedInput.value;
//         }

//         const hiddenInput = document.querySelector(
//           'input[name="selling_plan"]',
//         );

//         if (hiddenInput && hiddenInput.value) {
//           return hiddenInput.value;
//         }

//         const select = document.querySelector('select[name="selling_plan"]');

//         if (select && select.value) {
//           return select.value;
//         }

//         return null;
//       }

//       buildCartItems(qty) {
//         if (!this.isBottleProduct) {
//           return [];
//         }

//         const packs = this.getAvailablePacks();
//         const split = this.splitQuantity(qty, packs);

//         const sellingPlan = this.getSelectedSellingPlan();

//         return split.map((item) => {
//           const variantId = this.packData[item.pack].variantId;

//           const variant = this.productData.variants.find(
//             (v) => v.id === variantId,
//           );

//           const cartItem = {
//             id: variantId,
//             quantity: item.count,
//           };

//           if (sellingPlan && variant?.selling_plan_allocations?.length) {
//             const hasSellingPlan = variant.selling_plan_allocations.some(
//               (allocation) =>
//                 String(allocation.selling_plan_id) === String(sellingPlan),
//             );

//             if (hasSellingPlan) {
//               cartItem.selling_plan = sellingPlan;
//             }
//           }

//           return cartItem;
//         });
//       }

//       getActivePackFromVariant() {
//         const variantId = this.variantIdInput?.value;

//         const variant = this.productData.variants.find(
//           (v) => String(v.id) === String(variantId),
//         );

//         if (!variant) return null;

//         const match = variant.title.match(/\d+/);
//         if (!match) return null;

//         return parseInt(match[0], 10);
//       }

//       updateMode() {
//         if (!this.isBottleProduct) return;

//         const qty = parseInt(this.quantityInput.value) || 1;
//         const availablePacks = this.getAvailablePacks();
//         const maxPack = Math.max(...availablePacks);
//         const activePack = this.getActivePackFromVariant();

//         if (activePack === 1 && qty > 1) {
//           this.element.classList.add("split-mode");
//           return;
//         }

//         this.element.classList.remove("split-mode");
//       }
//     },
//   );
// }


if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message',
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    },
  );
}
